import { ExerciseIntensities, IntensityLevel } from "@cf-shared/data-model/fitness-plan";
import { TrainingLevel } from "@cf-shared/data-model/training-level";

export function getIntensityForSubSlot(subSlotId: string) {
  if (slotIntensityConstants[subSlotId]) {
    return slotIntensityConstants[subSlotId];
  }

  return getDefaultIntensities();
}

export function getDefaultIntensities(): ExerciseIntensities {
  return {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 75,
      [IntensityLevel.DUPheavy]: 85,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 85,
      [IntensityLevel.DUPlight]: 80,
      [IntensityLevel.DUPheavy]: 90,
      [IntensityLevel.TUPlight]: 75,
      [IntensityLevel.TUPmedium]: 85,
      [IntensityLevel.TUPheavy]: 90,
    },
  };
}

const slotIntensityConstants: { [key: string]: ExerciseIntensities } = {
  ["$rdl"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$squat"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.Intensified]: 90,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 85,
      [IntensityLevel.DUPlight]: 80,
      [IntensityLevel.DUPheavy]: 90,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 85,
      [IntensityLevel.DUPlight]: 80,
      [IntensityLevel.DUPheavy]: 90,
      [IntensityLevel.TUPlight]: 80,
      [IntensityLevel.TUPmedium]: 85,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$squat$1"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.Intensified]: 90,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 85,
      [IntensityLevel.DUPlight]: 80,
      [IntensityLevel.DUPheavy]: 90,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 85,
      [IntensityLevel.DUPlight]: 80,
      [IntensityLevel.DUPheavy]: 90,
      [IntensityLevel.TUPlight]: 80,
      [IntensityLevel.TUPmedium]: 85,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$unilateral_squat"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$chin_up"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$pull_up"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$bench_press"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$bench_press$1"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$ohp"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$ohp$4"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
      [IntensityLevel.TUPlight]: 70,
      [IntensityLevel.TUPmedium]: 80,
      [IntensityLevel.TUPheavy]: 90,
    },
  },
  ["$hip_extension"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.Intensified]: 80,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 75,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 80,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 80,
      [IntensityLevel.DUPlight]: 70,
      [IntensityLevel.DUPheavy]: 85,
    },
  },
  ["$shoulders"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$lateral"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$lateral$1"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$hams"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$hams$2"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$calves"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$calves$4"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$lats"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$lats$3"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$rear_delt"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$rear_delt$2"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$biceps"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$biceps$4"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$quads"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$triceps"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$triceps$2"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$glutes"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$chest"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$chest$2"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$soleus"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$upper_traps"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$abs"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$glute_medius"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
  ["$glute_medius$2"]: {
    [TrainingLevel.Novice]: {
      [IntensityLevel.Initial]: 60,
      [IntensityLevel.Intensified]: 70,
    },
    [TrainingLevel.Intermediate]: {
      [IntensityLevel.Initial]: 65,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 70,
    },
    [TrainingLevel.Advanced]: {
      [IntensityLevel.Initial]: 70,
      [IntensityLevel.DUPlight]: 60,
      [IntensityLevel.DUPheavy]: 75,
    },
  },
};